import React from "react"
import {
  CompensatedOperation,
  DeliveredOperation,
  Operation,
  OperationWrapper,
  PlacedOperation,
  RefundedOperation,
  ReleasedOperation
} from "./OrderLine.styled"
import { Order, OrderHistory, OrderLine } from "lib/types/generated/graphql-types"
import { OrderHistoryOperations } from "../../../classes/order/OrderHistoryOperations"
import { Cancellations } from "../../../classes/order/Cancellations"

type Props = {
  orderLine: OrderLine
  compensationTotal: number
  orderHistory: OrderHistory
  order: Order
  upsell: boolean
}

const OrderLineOperations = ({ orderLine, compensationTotal, orderHistory, order, upsell }: Props) => {
  const isPartOfBundle = (orderLine?.discountOutcome?.bundles?.length ?? 0) > 0
  const orderOperations = new OrderHistoryOperations(orderHistory?.operations)
  const cancellation = new Cancellations(order.Cancellations)

  const deliveredOrderLine = orderOperations.getDeliveredOrderLine(orderLine.id)

  const refundedOrderLine = orderOperations.getRefundedOrderLine(orderLine.id)

  const releasedOrderLine = orderOperations.getReleasedOrderLine(orderLine.id)

  const cancelledOrder = cancellation.orderCancelled(order.id)

  const getOperation = () => {
    if (refundedOrderLine) {
      if (refundedOrderLine.quantity !== orderLine.quantity)
        return <RefundedOperation>Returned in part</RefundedOperation>
      return <RefundedOperation>Returned</RefundedOperation>
    }
    if (deliveredOrderLine) {
      if (deliveredOrderLine.quantity !== orderLine.quantity)
        return <DeliveredOperation>Delivered in part</DeliveredOperation>
      return <DeliveredOperation>Delivered</DeliveredOperation>
    }
    if (releasedOrderLine) return <ReleasedOperation>Released</ReleasedOperation>
    if (cancelledOrder) return <RefundedOperation>Cancelled</RefundedOperation>
    return <PlacedOperation>Placed</PlacedOperation>
  }

  return (
    <OperationWrapper>
      <div>
        {upsell && <Operation>Upsell</Operation>}
        {isPartOfBundle && <Operation>Part of bundle</Operation>}
        {orderLine.hasExternalPrice && <Operation>External price</Operation>}
      </div>
      <div>
        {compensationTotal > 0 && <CompensatedOperation>Compensated</CompensatedOperation>}
        {getOperation()}
      </div>
    </OperationWrapper>
  )
}

export default OrderLineOperations
